import React from 'react'

const Trend: React.FC<{ className: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.5798 6.25H13.0006V5H18.6256V10.625H17.3756V7.23172L11.1452 14.0285L7.37554 10.2589L2.81748 14.8169L1.93359 13.9331L7.37554 8.49112L11.1059 12.2215L16.5798 6.25Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default Trend
